import nodeStyles from '../SchemeNode/SchemeNode.module.css';

import React, { useState } from 'react';
import Icon from '../../../helpers/components/Icon';
import addIcon from '../../../assets/svg/add-01.svg';
import classNames from 'classnames';
import { schemesStore } from '../../../store/mobx/schemes.store';
import ObjectSelectMenu from '../SchemeMenus/ObjectSelectMenu';
import { SchemeNodeTypes } from 'consts/scheme.consts';

const InsertSchemeNodeButton = ({ parentNode = undefined }) => {
  const { upsertSchemeNode, selectedScheme } = schemesStore;

  const [isHovered, setIsHovered] = useState(false);
  const [addNodeMenuOpen, setAddNodeMenuOpen] = React.useState(false);

  const handleAddClick = async (object) => {
    if (object.node !== SchemeNodeTypes.storage && !object.type) return;
    setIsHovered(false);
    return await upsertSchemeNode({
      id_scheme: selectedScheme?.id,
      id_parent: parentNode?.id,
      type: object.node,
      objects: object.type
        ? [
            object.type && {
              id: object.value,
              type: object.type,
              ...(typeof object.derived === 'boolean'
                ? {
                    derived: object.derived,
                  }
                : {}),
            },
          ]
        : [],
      resources: [],
    });
  };

  const handleOpenMenuClick = () => {
    setAddNodeMenuOpen(true);
  };

  return (
    <div
      style={{
        position: 'relative',
        margin: '10px 10px 10px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        width: 'fit-content',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleOpenMenuClick}
    >
      <div
        className={classNames(nodeStyles.containerImgSize)}
        style={{
          background: 'var(--color-brand)',
          borderRadius: '50%',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          filter: isHovered ? 'brightness(90%)' : 'none',
        }}
      >
        <Icon color={'#fff'} src={addIcon} width={'24px'} height={'24px'} />
      </div>
      <div
        style={{
          color: 'var(--border-gray)',
          fontSize: '15px',
          fontFamily: 'Ubuntu-R',
          letterSpacing: '0.04em',
          cursor: 'pointer',
          width: 'fit-content',
          textDecoration: isHovered ? 'underline' : 'none',
        }}
      >
        Добавить новый этап
      </div>
      {addNodeMenuOpen && (
        <ObjectSelectMenu onSelect={handleAddClick} onClose={() => setAddNodeMenuOpen(false)} />
      )}
    </div>
  );
};

export default InsertSchemeNodeButton;
